import { createContext, useContext } from 'react';

export interface BottomSheetContextProps {
  close: () => void;
}

const BottomSheetContext = createContext<BottomSheetContextProps>({
  close: () => null,
});

export const useBottomSheetContext = () => {
  return useContext(BottomSheetContext);
};

export default BottomSheetContext;
